var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.object.user.name
        ? _c(
            "router-link",
            { attrs: { to: "/identifications/" + _vm.object.id, tag: "span" } },
            [
              _vm.object.user.photo
                ? _c("img", {
                    staticStyle: { float: "left", "margin-right": "5px" },
                    attrs: { height: "30", src: _vm.object.user.photo },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.object.user.name))]),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("global.fromDate")) +
                    " " +
                    _vm._s(_vm.object.user.fromDate)
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.object.user.name
        ? _c("span", [
            _vm._v("\n        " + _vm._s(_vm.object.user) + "\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }